// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"index_boxContainer__1QuyP"};